import type {MessageContent} from '../../types'

export const textFromMessageContent = (message: MessageContent) => {
  if (typeof message === 'string') {
    return message
  } else {
    return message[1].text
  }
}
